export async function getRecaptchaSiteKey(): Promise<string> {
  const url = `${CMS.contextPath}/.rest/delivery/form-config/captcha`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    return data?.siteKey ?? '';
  } catch (error) {
    console.error(error);
    return '';
  }
}

interface MagnoliaProperty {
  name: string;
  type: string;
  multiple: boolean;
  values: string[];
}

interface MagnoliaContentNode {
  name: string;
  type: string;
  path: string;
  identifier: string;
  properties: MagnoliaProperty[];
  nodes: MagnoliaContentNode[] | null;
}

export interface ValidatorsResponse {
  name: string;
  type: string;
  path: string;
  identifier: string;
  properties: MagnoliaProperty[];
  nodes: MagnoliaContentNode[];
}

export async function getFormValidators(): Promise<ValidatorsResponse> {
  const url = `${CMS.contextPath}/.rest/nodes/v1/config/modules/form/config/validators?depth=3&includeMetadata=false`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    return data as ValidatorsResponse;
  } catch (error) {
    console.error(error);
    return {} as ValidatorsResponse;
  }
}
